import * as Yup from 'yup';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { MdConfirmationNumber } from 'react-icons/md';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Field from 'legacy/common/components/wysiwyg-form/Field';

interface MaxTicketsModalProps {
  initialValues: { maxTicketsPerTransaction: string };
  onClose: () => void;
  onSave: (label: string) => void;
}

const MaxTicketsModal: React.FC<MaxTicketsModalProps> = ({
  initialValues,
  onClose,
  onSave
}) => {
  const { t } = useTranslation(['events']);

  const MaxTicketsSchema = Yup.object().shape({
    maxTicketsPerTransaction: Yup.number()
      .max(10, 'must be less than or equal to 10')
      .min(1, 'must be less than or equal to 1')
      .required('Required field')
  });

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        onSave(values.maxTicketsPerTransaction);
        onClose();
      }}
      enableReinitialize
      validationSchema={MaxTicketsSchema}
    >
      {({ submitForm }) => (
        <Modal
          type={ModalType.SMALL}
          onClose={onClose}
          autoHeight
          visible
          icon={<MdConfirmationNumber size={20} />}
          title={t('events:settings.maxTickets.modal.title')}
          renderFooter={() => (
            <Button type={ButtonType.Primary} onClick={submitForm}>
              {t('events:settings.maxTickets.modal.saveButton')}
            </Button>
          )}
        >
          <div className="px-4 pt-6">
            <Field
              type="number"
              label={t('events:settings.maxTickets.modal.maxTicketsLabel')}
              id="maxTicketsPerTransaction"
              name="maxTicketsPerTransaction"
              clearable
              placeholder={t(
                'events:settings.maxTickets.modal.maxTicketsPlaceholder'
              )}
            />
          </div>
        </Modal>
      )}
    </Formik>
  );
};

export default MaxTicketsModal;
